import { ButtonIconPermissioned } from "components/ButtonIconPermissioned/ButtonIconPermissioned";
import { ModalCreateColumnFromExistingTable } from "pages/gdt/modals/ModalCreateColumn/ModalCreateColumnFromExistingTable";
import { useState } from "react";

export interface QuickActionInsertColumnsFromTableProps {
  tableId: string;
}

export const QuickActionInsertColumnsFromTable = ({
  tableId,
}: QuickActionInsertColumnsFromTableProps) => {
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    setShowModal(true);
  };
  const onClose = () => {
    setShowModal(false);
  };
  return (
    <>
      <ButtonIconPermissioned
        requiredPermission="edit"
        defaultTooltip="Insert columns from another table"
        aria-label="Insert columns from another table"
        size="xs"
        iconType="link"
        onClick={() => void handleClick()}
        id="quickActionInsertColumnsFromExisting"
      />
      {showModal && (
        <ModalCreateColumnFromExistingTable
          tableId={tableId}
          onClose={onClose}
        />
      )}
    </>
  );
};
